import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'iv-salesforce-account-name',
  templateUrl: './salesforce-account-name.component.html',
  styleUrls: ['./salesforce-account-name.component.scss']
})
export class SalesforceAccountNameComponent implements OnInit {

  @Input() accountName: string = '';

  constructor() { }

  ngOnInit(): void {
    if (this.accountName === undefined) {
      this.accountName = '';
    }
  }

}
